export const useChartLocationCheck = () => {
  const { pathname } = window.location;
  if (pathname.includes('reports-template')) return true;

  return false;
};

export default useChartLocationCheck;
